/**
 * DLUX busy buttons.
 *
 * Puts a spinner on navigation CTAs between the click and the next page
 * painting. Opt in with data-dlux-busy on the anchor.
 *
 * Deliberately does nothing when the click will not navigate this tab:
 * modified clicks, middle clicks, target="_blank", downloads, and
 * non-http schemes such as mailto: and tel: all open elsewhere or not at
 * all, so a spinner would be left hanging.
 */
(function () {
  // If navigation is blocked or the user cancels, clear the state rather than
  // spinning forever.
  var SAFETY_MS = 8000;

  function isPlainLeftClick(e) {
    return e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
  }

  function navigatesThisTab(a) {
    if (a.target && a.target !== '_self') return false;
    if (a.hasAttribute('download')) return false;

    var href = a.getAttribute('href');
    if (!href || href === '#' || href.charAt(0) === '#') return false;

    var url;
    try {
      url = new URL(a.href, window.location.href);
    } catch (e) {
      return false;
    }
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;

    // Same page, only the fragment differs: no navigation, no spinner.
    if (
      url.origin === window.location.origin &&
      url.pathname === window.location.pathname &&
      url.search === window.location.search &&
      url.hash
    ) {
      return false;
    }
    return true;
  }

  function clear(el) {
    el.removeAttribute('aria-busy');
    if (el.__dluxBusyTimer) {
      window.clearTimeout(el.__dluxBusyTimer);
      el.__dluxBusyTimer = null;
    }
  }

  function onClick(e) {
    var el = e.currentTarget;
    if (el.getAttribute('aria-busy') === 'true') return;
    if (!isPlainLeftClick(e)) return;
    if (el.tagName === 'A' && !navigatesThisTab(el)) return;
    if (e.defaultPrevented) return;

    el.setAttribute('aria-busy', 'true');
    el.__dluxBusyTimer = window.setTimeout(function () {
      clear(el);
    }, SAFETY_MS);
  }

  function bind(scope) {
    (scope || document).querySelectorAll('[data-dlux-busy]').forEach(function (el) {
      if (el.__dluxBusyBound) return;
      el.__dluxBusyBound = true;
      el.addEventListener('click', onClick);
    });
  }

  bind(document);

  document.addEventListener('shopify:section:load', function (e) {
    bind(e.target);
  });

  /*
   * Back/forward cache. Chrome and Safari restore the page exactly as it was
   * left, spinner included, so a visitor who hits back would find a permanently
   * loading button. Clear on restore.
   */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-dlux-busy][aria-busy="true"]').forEach(clear);
  });

  // Same idea for a navigation the browser abandons.
  window.addEventListener('pagehide', function () {
    document.querySelectorAll('[data-dlux-busy][aria-busy="true"]').forEach(function (el) {
      if (el.__dluxBusyTimer) window.clearTimeout(el.__dluxBusyTimer);
    });
  });
})();
